
import { Component, Input, OnChanges, signal, SimpleChanges } from '@angular/core';

import { EasFormControl } from './easform';
import { FormControl } from '@angular/forms';
/*
"passwordsMatch": {
			"en": "Passwords match",
			"fr": "Passwords match"
		},
		"passwordsDoNotMatch": {
			"en": "Passwords do not match",
			"fr": "Passwords do not match"
		},
		"passwordAtLeast12Chars": {
			"en": "At least 12 characters",
			"fr": "At least 12 characters"
		},
		"passwordAtLeastOneLowerCase": {
			"en": "At least one lowercase letter",
			"fr": "At least one lowercase letter"
		},
		"passwordAtLeastOneUpperCase": {
			"en": "At least one uppercase letter",
			"fr": "At least one uppercase letter"
		},
		"passwordAtLeastOneNumber": {
			"en": "At least one number",
			"fr": "At least one number"
		},
		"passwordAtLeastOneSpecialChar": {
			"en": "At least one special character",
			"fr": "At least one special character"
		},
		"passwordStrengthText": {
			"en": "Password strength",
			"fr": "Password strength"
		},
*/


const PasswordChecks =  [
    {
      text: $localize `At least 12 characters`,
      test: /^(?=.{12,})/,
    },
    {
      text: $localize `At least one lowercase letter`,
      test: /^(?=.*[a-z])/,
    },
    {
      text: $localize `At least one uppercase letter`,
      test: /^(?=.*[A-Z])/,
    },
    {
      text: $localize `At least one number`,
      test: /^(?=.*\d)/,
    },
    {
      text: $localize `At least one special character`,
      test: /^(?=.*\W)/,
    }
];

export interface PasswordCheck {
    text: string;
    valid: boolean;
};

@Component({
    selector: 'eas-easform-control-password',
    templateUrl: './easform-control-password.component.html',
    styles: [],
    standalone: false
})
export class EasFormControlPasswordComponent implements OnChanges {

  @Input() easControl!: EasFormControl;
  @Input() errors!: string[];

  $checks = signal<PasswordCheck[]>([...PasswordChecks.map(check => ({ text: check.text, valid: false })), { text: $localize `Passwords match`, valid: false }]);
  public currentErrors: string[] = []

  confirm = new FormControl('');
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['easControl'] && this.easControl) {
      this.handleErrors();
    }
  }
  handleErrors() {
    this.currentErrors = [];
    if (this.easControl.control.errors) {
      for (const key in this.easControl.control.errors) {
        this.currentErrors = this.errors[key](key);
      }
    }
  }
  ngOnInit() {
    this.easControl.control.addValidators([
        control => {
            const value = control.value;
            if (!PasswordChecks.every(check => check.test.test(value))) {
                return { passwordStrength: true };
            } else {
                return null;
            }
        },
        control => {
            if (control.value !== this.confirm.value) {
                return { passwordsMatch: false };
            } else {
                return null;
            }
        }
    ])

    this.easControl.control.valueChanges.subscribe(value => {
        const checks = PasswordChecks.map(check => {
            return {
                text: check.text,
                valid: check.test.test(value)
            }
        });
        checks.push({
            text: $localize `Passwords match`,
            valid: value === this.confirm.value
        });
        this.$checks.set(checks);
    });

    this.confirm.valueChanges.subscribe(_value => {
        this.easControl.control.updateValueAndValidity();
    });
  }

}
